import { logger } from ".";
import { errorMessage } from "../consts";

/**
 * Format currency to German local layout
 * @param amount of money
 */
export const formatCurrency = (amount?: number | null): string => {
  if (typeof amount !== "number" || isNaN(amount)) {
    return "–";
  }
  return amount.toLocaleString("de-DE", {
    style: "currency",
    currency: "EUR",
  });
};
